import axios, { type AxiosError } from "axios";
import useSWR, { type SWRConfiguration } from "swr";

const IMMUTABLE_MODE_OPTION = {
  revalidateIfStale: false,
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
};

type Props = {
  url: string | null;
  params?: Record<string, string | string[]>;
  options?: SWRConfiguration;
  shouldFetch?: boolean;
};

// SWRキャッシュ経由でGETするフック。デフォルトでは再検証を行わない（immutableモード）。
// useSWR標準の再検証挙動が必要な場合はoptionsでrevalidate系オプションを有効化する。
export const useSWRData = <T>({ url, params, options, shouldFetch = true }: Props) => {
  const fetcher = (fetcherUrl: string): Promise<T> =>
    axios
      .get<T>(fetcherUrl, { params })
      .then((res) => res.data)
      .catch((err: AxiosError) => {
        throw new Error(err.message);
      });

  const key = shouldFetch && url ? [url, params] : null;

  return useSWR<T, Error>(key, ([fetcherUrl]: [string]) => fetcher(fetcherUrl), {
    ...IMMUTABLE_MODE_OPTION,
    ...options,
  });
};
